import { fetchContent } from "../services/ContentService";
import { setContent } from "../store/ContentStore";

const initialAppLoad = async () => {
    try {
        const data = await fetchContent();
        setContent(data); 
        console.log('Content loaded and stored in app state.');
    } catch (error) {
        console.error('Initial content load failed:', error);
    }
};

export default initialAppLoad;